import React from 'react'
import { Outlet } from 'react-router-dom'

import { useOptionalUser, useRequiredUser } from '@/hooks/use-user'

function WaitUntilUser({ children }: { children: React.ReactNode }) {
  const { isLoading } = useOptionalUser()

  if (isLoading) {
    return null
  }

  return children
}

function RedirectIfNoUser() {
  useRequiredUser()

  return <Outlet />
}

export default function ProtectedRoutes() {
  return (
    <WaitUntilUser>
      <RedirectIfNoUser />
    </WaitUntilUser>
  )
}
